import React from 'react';
import StripeForm from 'emerald-ui/lib/StripeForm';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: StripeForm, componentName: 'StripeForm' }], 'StripeForm'),
  description: (
    <span>
      This is an implementation of a Stripe form with the appropriate styles and validation.{' '}
      <strong>
        Note that you must import the Stripe JS file in your <span className="code">head</span> tag. Also, you need to
        run your development environment through <span className="code">https</span> in order to make the quick payment
        button work.
      </strong>
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { StripeForm },
      whiteBackground: true,
      code: `<div>
  <StripeForm
    showPostalCodeField
    showCardHolderName
    apiKey="pk_test_Y1kYqvIMSajQ072EhX4ZSZCX"
    paymentLabel="Emerald-UI test payment"
    paymentAmount={10}
    onSubmit={(token, errors) => {
      console.log('Stripe token', token);
      console.log('Errors', errors);
    }}
  />
</div>`,
    },
  ],
};
